// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Laos from '../_raw/flag/icon_flag_laos.png';

export default () => <img src={Laos} alt="Laos" />;
